import React from 'react';
import PropTypes from 'prop-types';
import { Link, useResolvedPath, useSearchParams } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Toolbar from './styles/Toolbar,';

function ReportToolbarWidget({ reportId }) {
  const [searchParams] = useSearchParams();
  const isSchedule = searchParams.get('schedule');

  const base = useResolvedPath('.');

  return (
    <Toolbar>
      {reportId && !isSchedule && (
        <Tooltip title="Создать отчет по расписанию">
          <IconButton component={Link} to={`?report=${reportId}&schedule=true`} size="small">
            <AddAlarmIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Отчеты по расписанию">
        <IconButton component={Link} to={`${base.pathname}/report-tasks`} size="small">
          <AccessTimeIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
}

ReportToolbarWidget.propTypes = {
  reportId: PropTypes.number.isRequired,
};

export default ReportToolbarWidget;
